








class RewardsProgramClass {

    el
    rewardsSummary
    rewardsHowItWorks

    constructor(el) {
        console.log('new RewardsProgramClass')
        this.el = el
        this.setupListener()

    }
    initialize() {
        console.log('RewardsProgramClass --> initialize')
        document.querySelector('main').classList.add('opacity-1')

    }

    buildRewardsSummary() {
        console.log('buildRewardsSummary')

        let content = document.createElement('div')
        content.classList.add("container-fluid","max-width","RewardsSummary")
        content.innerHTML = '<div class="row"><div class="col-12 col-md-6  col-lg-5 RewardsSummary__left-col-1"><div class="RewardsSummary__left-col-1-inner"><img class="RewardsSummary__left-col-1-image" alt="" src="https://cdn.shopify.com/s/files/1/0077/9966/8851/files/RewardsLogo-uncropped.png?v=1719424886" /></div></div><div class="col-12 col-md-6  col-lg-5  RewardsSummary__left-col-2"></div></div>'
        let rewardsSummaryLeftCol = content.querySelector(".RewardsSummary__left-col-1-inner")
        let rewardsSummaryRightCol= content.querySelector(".RewardsSummary__left-col-2")
        this.rewardsSummary.append(content)

        let img = document.createElement('img')
        img.setAttribute('src',"https://cdn.shopify.com/s/files/1/0077/9966/8851/files/Rewards_Hero_Image.png?v=1718306831")
        img.setAttribute('alt',"")
        rewardsSummaryRightCol.append(img)

        let stampedCustomerNotLoggedIn = this.rewardsSummary.querySelector('.stamped-rewards-widget-btn-holder.stamped-customer-not-logged-in')
        let stampedCustomerLoggedIn = this.rewardsSummary.querySelector('.stamped-rewards-widget-btn-holder.stamped-customer-logged-in')
        let stampedRewardsHistory = this.rewardsSummary.querySelector('.stamped-rewards-widget-btn-rewards-history')
        let stampedRewardsSignIn = this.rewardsSummary.querySelector('.stamped-rewards-widget-btn-sign-in')

        stampedCustomerNotLoggedIn.querySelector("a").classList.remove('stamped-rewards-widget-btn')
        stampedCustomerNotLoggedIn.querySelector("a").classList.add('btn','btn-green')

        stampedCustomerLoggedIn.querySelector("a").classList.remove('stamped-rewards-widget-btn')
        stampedCustomerLoggedIn.querySelector("a").classList.add('btn','btn-green')

        stampedRewardsHistory.classList.remove('stamped-rewards-widget-btn')
        stampedRewardsHistory.classList.add('btn','btn-green')

        stampedRewardsSignIn.classList.remove('stamped-rewards-widget-btn')
        stampedRewardsSignIn.classList.add('btn-underlined-link','font-md')

        rewardsSummaryLeftCol.append(this.rewardsSummary.querySelector('.stamped-rewards-widget-text-holder'))
        rewardsSummaryLeftCol.append(stampedCustomerNotLoggedIn)
        rewardsSummaryLeftCol.append(stampedCustomerLoggedIn)
    }

    buildHowItWorks() {
        console.log('buildHowItWorks')
        this.rewardsHowItWorks.querySelector('[data-target-id="section-step-one"] .stamped-rewards-widget-number').innerHTML = '<img alt="" src="https://cdn.shopify.com/s/files/1/0077/9966/8851/files/Steps_1-signup.png?v=1718308468" />'
        this.rewardsHowItWorks.querySelector('[data-target-id="section-step-two"] .stamped-rewards-widget-number').innerHTML = '<img alt="" src="https://cdn.shopify.com/s/files/1/0077/9966/8851/files/Steps_2-collect.png?v=1718308468" />'
        this.rewardsHowItWorks.querySelector('[data-target-id="section-step-three"] .stamped-rewards-widget-number').innerHTML = '<img alt="" src="https://cdn.shopify.com/s/files/1/0077/9966/8851/files/Steps_3-Redeem.png?v=1718308468" />'

    }


    setupListener() {
        let self = this
        let listenerInterval = setInterval(function(){
            if(document.querySelector('[data-widget-type="rewards-summary"] .stamped-rewards-widget-text-holder') &&
               document.querySelector('[data-widget-type="rewards-summary"] .stamped-rewards-widget-btn-holder.stamped-customer-logged-in')&&
               document.querySelector('[data-widget-type="rewards-summary"] .stamped-rewards-widget-btn-holder.stamped-customer-not-logged-in')){
                self.rewardsSummary = document.querySelector('[data-widget-type="rewards-summary"]')
                clearInterval(listenerInterval)
                self.buildRewardsSummary()
                self.initialize()
            }

        },100)

        let listenerInterval2 = setInterval(function(){

            if(document.querySelector('[data-widget-type="rewards-how-it-works"] [data-target-id="section-step-one"]') &&
               document.querySelector('[data-widget-type="rewards-how-it-works"] [data-target-id="section-step-two"]')&&
               document.querySelector('[data-widget-type="rewards-how-it-works"] [data-target-id="section-step-three"]')){
                self.rewardsHowItWorks = document.querySelector('[data-widget-type="rewards-how-it-works"]')
                clearInterval(listenerInterval2)
                self.buildHowItWorks()
            }

        },100)

        let listenerInterval3 = setInterval(function(){
            if(document.querySelector('[data-widget-type="rewards-earnings-v2"] .stamped-rewards-earnings')) {
                let nodelist = document.querySelectorAll('[data-widget-type="rewards-earnings-v2"] .stamped-rewards-widget-item')
                for (let i = 0; i < nodelist.length; i++) {
                    let el = nodelist[i]
                    el.querySelector('img').setAttribute('style',"")
                }
                nodelist = document.querySelectorAll('[data-widget-type="rewards-earnings-v2"] .stamped-rewards-widget-button')
                for (let i = 0; i < nodelist.length; i++) {
                    let el = nodelist[i]
                    //el.classList.remove("stamped-rewards-widget-button")
                    //el.classList.add("btn","btn-green")
                }
                clearInterval(listenerInterval3)
            }
        },100)

        let listenerInterval4 = setInterval(function(){
            if(document.querySelector('[data-widget-type="rewards-spendings-v2"] .stamped-rewards-spendings')) {
                document.querySelector('[data-widget-type="rewards-spendings-v2"] .stamped-rewards-spendings').classList.add('row')

                let nodelist = document.querySelectorAll('[data-widget-type="rewards-spendings-v2"] .stamped-rewards-widget-item')
                for (let i = 0; i < nodelist.length; i++) {
                    let el = nodelist[i]
                    el.setAttribute('class','col-10 col-sm-5 mb-md')
                }
                clearInterval(listenerInterval4)
            }
        },100)

        let listenerInterval5 = setInterval(function(){
            if(document.querySelector('[data-widget-type="rewards-referral"] .stamped-rewards-page-campaigns-refer')) {
                let rewardsReferral = document.querySelector('[data-widget-type="rewards-referral"]')

                let rewardsReferralContent = document.querySelector('[data-widget-type="rewards-referral"] .stamped-rewards-page-campaigns-refer')
                // stamped-rewards-widget
                let content = document.createElement('div')
                content.classList.add("container-fluid","max-width","RewardsReferral","mt-sm")
                //
                content.innerHTML = '<div class="row justify-content-center" ><div class="col-12 col-md-5 RewardsReferral__left-col-1 color-white"><div class="RewardsReferral__left-col-1-inner"></div></div><div class="col-12 col-md-5  RewardsReferral__left-col-2"><img class="RewardsReferral__left-col-1-image" alt="" src="https://cdn.shopify.com/s/files/1/0077/9966/8851/files/ReferFriend_image.jpg?v=1718636485" /></div></div>'
                let rewardsReferralLeftCol = content.querySelector(".RewardsReferral__left-col-1-inner")
                let rewardsReferralRightCol= content.querySelector(".RewardsReferral__left-col-2")
                rewardsReferralLeftCol.append(rewardsReferralContent)
                rewardsReferral.append(content)


                clearInterval(listenerInterval5)
            }
        },100)
    }
}



document.addEventListener("DOMContentLoaded", function(){

    const RewardsPrograms = new RewardsProgramClass()
})


